module.exports = __webpack_public_path__ + "img/cccc.5f064f85.jpg";